import { render, staticRenderFns } from "./InputPicCaptcha.vue?vue&type=template&id=2b6fa556&scoped=true&"
import script from "./InputPicCaptcha.vue?vue&type=script&lang=js&"
export * from "./InputPicCaptcha.vue?vue&type=script&lang=js&"
import style0 from "./InputPicCaptcha.vue?vue&type=style&index=0&id=2b6fa556&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6fa556",
  null
  
)

export default component.exports